import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/base/Button';

interface DeleteCompanyModalProps {
  show: boolean;
  companyName: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteCompanyModal = ({
  show,
  companyName,
  onClose,
  onConfirm
}: DeleteCompanyModalProps) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    try {
      await onConfirm();
      onClose();
    } catch (err: unknown) {
      if (err instanceof Error) setError(err.message);
      else setError('Failed to delete company');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Company</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        Are you sure you want to delete the company{' '}
        <strong>{companyName}</strong>?
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="button" // Prevent page refresh
          variant="secondary"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="button" // Prevent page refresh
          variant="danger"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Deleting...
            </>
          ) : (
            'Delete'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCompanyModal;
